import React from 'react'
import { DisclaimerMain } from '@shared/components/disclaimer-main'
import { Section } from '@shared/components/section'
import cx from 'classnames'

import { StateProps } from './model'

import styles from './style.module.scss'

export const View = ({ sectionProps }: StateProps) => {
	return (
		<Section fullWidth {...sectionProps} className={cx(styles.wrapper, sectionProps?.className)}>
			<DisclaimerMain />
		</Section>
	)
}
